import {
  FETCH_PROFILE_FAILED,
  FETCH_PROFILE_SUCCESS,
  IS_LOGIN_SUCCESS, LOGIN_FAILED, LOGIN_REQUESTED,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS
} from "./actionTypes";
import { UserState } from "./types";
import { UserActions } from "./actions";

const initialState: UserState = {
  isLogin: false,
  profile: null,
  loginPending: false,
  useInfo: null,
}

export default function commonReducer(state = initialState, action: UserActions): UserState {
  switch (action.type) {

    case IS_LOGIN_SUCCESS:
      return { ...state, isLogin: true, useInfo: action.payload }

    case LOGIN_REQUESTED:
      return { ...state, loginPending: true }
    case LOGIN_SUCCESS:
      return { ...state, loginPending: false, isLogin: true, profile: action.payload }
    case LOGIN_FAILED:
      return { ...state, loginPending: false }

    case LOGOUT_SUCCESS:
      return { ...state, isLogin: false, profile: null, useInfo: null, }

    case FETCH_PROFILE_SUCCESS:
      return { ...state, profile: action.payload }
    case FETCH_PROFILE_FAILED:
      return { ...state, profile: null }
    default:
      return state
  }
}